import styled from 'styled-components';
import { font, color, media } from 'style';

export default {
  Container: styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
  `,
  TextContainer: styled.div`
    text-align: center;
    margin-bottom: 50px;
  `,
  Subtitle: styled.div`
    font-size: ${font.size.large};
    margin-top: 10px;
  `,
  RequirementsContainer: styled.div`
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;

    ${media.md`
      flex-direction: row;
      max-width: 700px;
      width: 100%;
    `}
  `,
  Item: styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    max-width: 190px;
    width: 100%;
    text-align: center;
    &:not(:last-child) {
      margin-bottom: 50px;
    }

    ${media.md`
    margin-bottom: 0px;
    `}
  `,
  ItemIcon: styled.div`
    position: relative;
    --size: 120px;
    min-width: var(--size);
    min-height: var(--size);
    width: var(--size);
    height: var(--size);
    background-color: ${color.hmPurple4};
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 50%;
    margin-bottom: 5px;
  `,
  ItemSmallLabel: styled.div`
    font-size: ${font.size.small};
    text-transform: uppercase;
    font-weight: ${font.weight.bold};
    color: ${color.hmGrey3};
    margin: 5px 0px;
  `,
  ItemLabel: styled.div`
    font-size: 17px;
    font-weight: ${font.weight.bold};
  `,
};
